// @ts-nocheck
import moment from 'moment';
import React, { useEffect, useRef } from 'react';

export const ChatBroadcast = ({ broadcastMsg, investorId, }) => {
    const chatContainerRef = useRef(null);

    useEffect(() => {
        // Wait for DOM update before setting the scroll
        setTimeout(() => {
            if (chatContainerRef.current) {
                chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
            }
        }, 0); // Delay set to 0 to ensure it happens after render
    }, [broadcastMsg]);  // Depend on broadcastMsg to trigger when new messages arrive
    return (
        <div
            role='region'
            ref={chatContainerRef}
            className="bg-zinc-100 flex flex-col min-h-[70vh] max-h-[75vh] mt-2 scrollbar-thin  scrollbar-track-gray-200 overflow-y-auto"
        >
            {
                broadcastMsg
                    ?.filter(data => data.message && data.message !== "" || data.selfMessage && data.selfMessage !== null) // Filter out empty messages
                    .map((data, index) => {

                        return (
                            (data.userId == investorId && data.selfMessage && data.actionType !== "RetractAsk" && data.actionType !== "RetractLocal") ? (

                                // Message from the user
                                <div className="flex justify-end relative p-[4px] rounded-md" role='document' aria-label='right' key={index}>
                                    <div className="p-2 bg-green-100 w-fit relative max-w-[90%]">
                                        <div className="w-fit text-sm mr-[70px] right-test" >
                                            {data.selfMessage}
                                        </div>
                                        <span className="absolute right-2 bottom-0 text-xs text-gray-500" >
                                            {new Date(data.createdTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                // Message from other users
                                <>
                                    {(((data.actionType == "RetractAsk" || data.actionType == "RetractLocal") && (data.userId == investorId)) ? data.selfMessage : data.message) &&
                                        <div className="flex justify-start relative p-[4px] rounded-md" role='document' aria-label='left' key={index}>
                                            <div className="p-2 bg-white w-fit relative max-w-[90%]">
                                                <div
                                                    className="w-fit text-sm mr-[70px] left-test"
                                                    role="document"
                                                    aria-label="left"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            (data.actionType === "RetractAsk" || data.actionType === "RetractLocal") && data.userId === investorId
                                                                ? `${data.selfMessage}`
                                                                : typeof data.message === 'string' ? data.message : ''
                                                    }}
                                                />
                                                {typeof data.message !== "string" ? <p className='text-sm'>
                                                    {data.message}
                                                </p> : <></>}
                                                <span className="absolute right-2 bottom-0 text-xs text-gray-500">
                                                    {new Date(data.createdTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                                                </span>
                                            </div>
                                        </div>

                                    }
                                </>
                            )
                        )
                    })
            }
        </div>
    );
}

